<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col v-if="richgoUserLinkInfo === null" cols="12" sm="8" md="8" lg="6" xl="4" align="center" justify="center">
        <v-card max-width="350" class="pa-md-2">
          <v-card-text class="font-weight-bold title text-center">코드를 입력해주세요</v-card-text>
          <v-text-field
              v-model="richgoUserId"
              :value="richgoUserId"
              :rules="richgoUserRule"
              :success="richgoUserSuccess"
              label="24자리 코드를 입력해주세요."
              prepend-icon="mdi-card-bulleted"
          ></v-text-field>

          <v-btn
              class="mt-5"
              color="primary"
              @click="clickRegisterRichgoUserLink"
          >
            연동하기
          </v-btn>
        </v-card>
      </v-col>
      <v-col v-else cols="12" sm="8" md="8" lg="6" xl="4" align="center" justify="center">
        <v-card max-width="350" class="pa-md-2">
          <v-card-text class="font-weight-bold title text-center">리치고 연동 정보</v-card-text>
          <v-card-text class="font-weight-bold text-center">연동 코드
            <br>
            {{this.richgoUserLinkInfo["code"]}}</v-card-text>
          <v-card-text class="font-weight-bold text-center">구독 기간
            <br>{{(this.richgoUserLinkInfo["startDate"] || "").split('T')[0]}} ~ {{(this.richgoUserLinkInfo["endDate"] || "").split('T')[0]}}
          </v-card-text>

          <v-btn
              class="mt-5"
              color="primary"
              @click="clickUnregisterRichgoUserLink"
          >
            연동 해제
          </v-btn>
          <v-card-text class="font-weight-bold text-center"></v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from '../../mixins/api';
import {mapActions} from "vuex";
import store from "@/store";

export default {
  name: "RichgoUserLink",
  async created() {
    await this.getRichgoUserLink();
  },
  data() {
    return {
      richgoUserId: "",
      richgoUserRule: [
        v => !(v === "") || "24자리 코드를 입력해주세요.",
        v => this.validRichgoUserId(v) || "잘뭇된 코드입니다."
      ],
      richgoUserLinkInfo: null
    }
  },
  ...mapActions(["forceUpdateAccessToken"]),
  computed: {
    richgoUserSuccess() {
      return this.validRichgoUserId(this.richgoUserId);
    },
  },
  methods: {
    validRichgoUserId(v) {
      return /^(\w){24}$/.test(
          v
      );
    },
    async getRichgoUserLink() {
      const response = await api.methods.getRichgoLink();
      this.richgoUserLinkInfo = response.result;
    },
    async clickRegisterRichgoUserLink() {
      if (this.validRichgoUserId(this.richgoUserId)) {
        let response = await api.methods.registerRichgoLink(this.richgoUserId);
        if (response.statusCode === 200) {
          alert('코드가 등록되었습니다.');
          await this. getRichgoUserLink();
          await store.dispatch("forceUpdateAccessToken");
          this.$router.go(0);
        } else {
          alert(response.result);
        }
      }
    },
    async clickUnregisterRichgoUserLink() {
      let response = await api.methods.unregisterRichgoLink();
      if (response.statusCode === 200) {
        alert('코드가 해제되었습니다.');
        await this. getRichgoUserLink();
        await store.dispatch("forceUpdateAccessToken");
        this.$router.go(0);
      } else {
        alert(response.result);
      }
    }
  }
}
</script>

<style scoped>

</style>
